import React from 'react';

import {
  SellerNavIconLogout,
  SellerNavIconOrders,
  SellerNavIconOverview,
  SellerNavIconSettings,
  SellerNavIconWishlist,
} from './sellerNavItems';

/** @param {React.ComponentProps<'svg'>} props */
export const CustomerNavIconOverview = SellerNavIconOverview;

/** @param {React.ComponentProps<'svg'>} props */
export const CustomerNavIconOrders = SellerNavIconOrders;

/** @param {React.ComponentProps<'svg'>} props */
export const CustomerNavIconSettings = SellerNavIconSettings;

export const CustomerNavIconLogout = SellerNavIconLogout;

/** @param {React.ComponentProps<'svg'>} props */
export const CustomerNavIconWishlist = SellerNavIconWishlist;

/** Primary customer hub navigation (overview, orders, settings). */
export const CUSTOMER_NAV_ITEMS = [
  {
    routeName: 'CustomerDashboardPage',
    params: {},
    messageId: 'CustomerDashboard.nav.overview',
    Icon: CustomerNavIconOverview,
  },
  {
    routeName: 'InboxPage',
    params: { tab: 'orders' },
    messageId: 'CustomerDashboard.nav.orders',
    Icon: CustomerNavIconOrders,
  },
  {
    routeName: 'WishlistPage',
    params: {},
    messageId: 'CustomerDashboard.nav.wishlist',
    Icon: CustomerNavIconWishlist,
  },
  {
    routeName: 'ContactDetailsPage',
    params: {},
    messageId: 'CustomerDashboard.nav.settings',
    Icon: CustomerNavIconSettings,
  },
];

/** Main customer links (excluding Settings parent — account routes nest under it). */
export const CUSTOMER_DASHBOARD_MAIN_NAV_ITEMS = CUSTOMER_NAV_ITEMS.filter(
  item => item.routeName !== 'ContactDetailsPage'
);

export const CUSTOMER_SETTINGS_NAV_PARENT = CUSTOMER_NAV_ITEMS.find(
  item => item.routeName === 'ContactDetailsPage'
);
